//import Libraries
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as axios from 'axios';
import {storageRef} from '../../../firebase';

//import Components
import Language from '../../../language/language.json';
import BlogCard from './BlogCard/BlogCard';
import BlogModal from './BlogModal/BlogModal';
import BlogItem from './BlogItem/BlogItem';
import {Modal} from 'reactstrap';

import * as communityActions from '../actions/communityActions';

//import Style classes
import './Blog.css';

const listLength = 8;

class Blog extends Component{
    constructor(props) {
        super(props);

        this.state = {
            listPage: 0,
            listOpen: false,
            openList: -1,
            openBlogModal: -1,
            activeTab : 'news',

            modalContent : 'loading....',
            listContent : 'loading....',
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if((prevState.openBlogModal !== this.state.openBlogModal) && this.state.openBlogModal !== -1) {
            this.loadHTMLContentFromStorage('modalContent', this.state.openBlogModal);
        }
        if((prevState.openList !== this.state.openList) && this.state.openList !== -1) {
            this.loadHTMLContentFromStorage('listContent' , this.state.openList);
        }
    }

    loadHTMLContentFromStorage = (target, id) => {
        // if(!this.props.articles[index].seen){
        //     this.props.onAddArticleView(this.props.articles[index], index)
        // }

        const articleRef = storageRef.child(`articles/${id}.html`);
        articleRef.getDownloadURL()
            .then((url) => {
                axios.get(url, {
                })
                    .then((res) => {
                        this.setState({
                            [target] : res.data
                        })
                    })
                    .catch((e)=>{
                    })
            })
            .catch((e) => {
            })
    }

    onTabClick = (e) => {
        this.setState({
            activeTab : e.target.getAttribute('name'),
            openList : -1,
            listOpen : false,
        })
    }

    prevPageHandler = () => {
        let currPage = this.state.listPage;
        if(!this.state.listPage <= 0)this.setState({listPage: currPage - 1});
    }

    nextPageHandler = () => {
        let currPage = this.state.listPage;
        this.setState({listPage: currPage + 1})
    }
    pageSetter = (idx) => {
        this.setState({listPage : idx});
    }
    blogListClickHandler = (id)=>{
        console.log('click');
        if(this.state.openList !== id){
            this.setState({listOpen: true, openList: id, listContent : 'loading....'})
        }else if(this.state.listOpen && this.state.openList === id){
            this.setState({listOpen: false, openList: -1, listContent : 'loading....'});
        }
    }
    closeBlogModal = () => {
        this.setState({ openBlogModal: -1 })
    }
    openBlogModal = (articleId) => {
        this.setState({
            openBlogModal: articleId,
            modalContent : 'loading....'
        });
    }
    render(){
        const lang = this.props.universal.language;
        const tempList = [...this.props.articles].sort((a, b) => (new Date(a.date) > new Date(b.date)) ? -1 : (new Date(a.date) > new Date(b.date)) ? ((a.category > b.category) ? -1 : 1) : 1 );
        const cards = 
        <div className="BlogCardWrapper">
            {tempList.map((obj, idx)=>{
                if(idx < 4) return <BlogCard data={obj} key={idx} idx={idx} lang={lang} onClick={()=>this.openBlogModal(obj.id)}/> })}
        </div>
        
        const filteredArticles = this.props.articles.filter(obj => {
            return obj.category === this.state.activeTab;
        })
        console.log(filteredArticles);
        filteredArticles.sort((a, b) => (new Date(a.date) > new Date(b.date)) ? -1 : (new Date(a.date) > new Date(b.date)) ? ((a.category > b.category) ? -1 : 1) : 1 )
        console.log(filteredArticles);
        const list = filteredArticles.map((obj, idx)=>{
            if(this.state.listPage * listLength <= idx && idx < this.state.listPage * listLength + listLength){
                let addClass = this.state.listOpen === true && this.state.openList === obj.id ? "open" : "";
                return (
                    <BlogItem 
                        totalLength={filteredArticles.length}
                        addClass={addClass}
                        openList={this.state.openList}
                        data={obj}
                        index={idx} 
                        key={idx}
                        onTitleClick={this.blogListClickHandler}
                        text={this.state.listContent}
                    />
                )
            }
        })
        console.log(list);
        let listPageLength = Math.ceil(filteredArticles.length/listLength);
        let listPageArray = [];
        for(var i = 0; i < listPageLength; i++){
            listPageArray[i] = i;
        }

        const pagination = listPageArray.map((obj, idx)=>{
            return <li key={idx} onClick={()=>this.pageSetter(obj)} className={"PageButton"+(obj==this.state.listPage ? " active" : null)}>{obj+1}</li>
                })

        //인덱스를 찾는다
        let modalTitleIndex = 0;
        for(let i = 0; i < this.props.articles.length; ++i) {
            if(this.props.articles[i].id === this.state.openBlogModal){
                modalTitleIndex = i;
                break; 
            }
        }

        const blogModal = this.state.openBlogModal !== -1 ? 
            <Modal className="CustomModal"
                isOpen={this.state.openBlogModal !== -1 ? true : false} 
                toggle={this.closeBlogModal}
                onClosed={true}
            >
                <BlogModal
                    title={this.props.articles[modalTitleIndex].title}
                    text={this.state.modalContent}
                />
            </Modal> : null
        return (
            <React.Fragment>
            {blogModal}
            <div className="Blog">
                <h2>최근 글 목록</h2>
                {cards}
            </div>
            <div className="BlogList">
                <h2>게시글</h2>
                <div className="ArticleWrapper">
                    <div className="Category">
                        <div 
                            name="news" 
                            className={this.state.activeTab === 'news' ? "active" : ''}
                            onClick={this.onTabClick}
                        >
                            <h3 name="news">대영소식</h3>
                        </div>
                        <div 
                            name="reference" 
                            className={this.state.activeTab === 'reference' ? "active" : ''}
                            onClick={this.onTabClick}
                        >
                            <h3 name="reference">자료실</h3>
                        </div>
                    </div>
                    <div className="Articles">{list}</div>
                </div>
                
                <ul className="Pagination">
                    {this.state.listPage !== 0 ?
                        <li id="PrevButton" className="PageButton" onClick={this.prevPageHandler}>{"<"}</li>: null}
                    {pagination}
                    {this.state.listPage == listPageLength - 1 ?
                        null : <li id="NextButton" className="PageButton" onClick={this.nextPageHandler}>{">"} </li>}
                </ul>
            </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return { 
        universal: state.universal 
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        onAddArticleView : (article, index) => {
            dispatch(communityActions.addArticleView(article, index))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Blog);


// WEBPACK FOOTER //
// ./src/pages/Community/Blog/Blog.js